import { useLayoutEffect } from 'react'

interface UseScrollIntoViewOptions extends ScrollIntoViewOptions {
    condition?: boolean
}

export const useScrollIntoView = (el: null | Element, options: UseScrollIntoViewOptions) => {
    useLayoutEffect(() => {
        const { condition = true, ...scrollOptions } = options

        if (!el || !condition) {
            return
        }

        el.scrollIntoView(scrollOptions)
    }, [options])
}
